/* eslint-disable */
import axios from "axios";
import store from "@/store";
import jwt_decode from "jwt-decode";

export default {
  name: "sitesummary",

  async mounted() {
    this.roleprivileges = store.getters.getRolesprivilegeData;
    this.defaultdashboard = store.getters.getdefaultdashboard;

    await this.loadstudy();
    await this.setdefaultstudy();
    await this.getcount();

    // KPI API (study-level)
    await this.getenrolmentpercentage();

    // reload when study changes
    window.addEventListener("studyIdChanged", async () => {
      this.defaultdashboard = store.getters.getdefaultdashboard;
      this.roleprivileges = store.getters.getRolesprivilegeData;

      await this.loadstudy();
      await this.setdefaultstudy();
      await this.getcount();

      await this.getenrolmentpercentage();
    });
  },

  watch: {
    // Used ONLY for Date Range chart now
    commonSiteId: {
      immediate: false,
      handler: async function (siteId) {
        if (!siteId) return;
        await this.fetchSiteEnrollmentOnce(siteId);
      },
    },
  },

  data() {
    return {
      roleprivileges: "",
      defaultdashboard: "",

      baseUrl: `${process.env.VUE_APP_Service_URL}/management/study/`,
      baseapi: process.env.VUE_APP_Service_URL,

      studies: [],
      currentStudy: "",
      userId: "",
      valnow: "",
      studyId: "",

      sites: [],
      siteCode: "",

      // Date range dropdown selection (only for date range chart)
      commonSiteId: "",

      // KPI
      kpis: {
        totalPlanned: 0,
        totalActual: 0,
        activeSites: 0,
        enrollmentPercent: 0,
      },

      // Site Summary chart
      summaryLoading: false,
      summaryChartKey: Date.now(),
      summarychart: {
        chartOptions: {
          stroke: { width: 2 },
          chart: { toolbar: { show: false }, id: "site-summary-chart" },
          dataLabels: { enabled: false },
          plotOptions: { bar: { borderRadius: 4, horizontal: true } },
          xaxis: {
            title: {
          text: "Count",
        },
            categories: ["New", "Open", "Enrolled", "Completed", "Terminated"],
          },
           yaxis: {
        title: {
          text: "Status",
        },
      },
        },
        dataseries: [{ name: "Site Summary", data: [0, 0, 0, 0, 0] }],
      },

      // Subject Summary chart
      patientchart: {
        piechartOptions: {
          chart: { width: "100%", type: "pie" },
          labels: [
            this.$t("navigations.new"),
            this.$t("navigations.enrolled"),
            this.$t("navigations.withdrawn"),
            this.$t("navigations.completed"),
            this.$t("navigations.visit ongoing"),
          ],
          responsive: [
            {
              breakpoint: 480,
              options: {
                pie: { size: 200 },
                chart: { toolbar: { show: false }, width: 200 },
                legend: { position: "bottom" },
              },
            },
          ],
        },
        piedataseries: [0, 0, 0, 0, 0],
      },

      // -------------------------
      // Site Level Planned vs Actual (ALL SITES) - API-driven separately
      // -------------------------
      siteLevelLoading: false,
      siteLevelData: {
        categories: [],
        planned: [],
        actual: [],
      },

      // -------------------------
      // Date Range chart (SINGLE SITE) - API-driven
      // -------------------------
      dateRangeLoading: false,
      dateRange: {
        siteCodeLabel: "",
      },
      dateRangeData: {
        categories: [],
        planned: [],
        actual: [],
      },
    };
  },

  computed: {
    // Prefer API percentage if available, else compute
    enrollmentPercent() {
      const apiPct = Number(this.kpis.enrollmentPercent);
      if (Number.isFinite(apiPct) && apiPct > 0) return apiPct;

      const planned = Number(this.kpis.totalPlanned) || 0;
      const actual = Number(this.kpis.totalActual) || 0;
      if (!planned) return 0;
      return Math.round((actual / planned) * 100);
    },

    hasPatientPieData() {
      const arr = this.patientchart?.piedataseries || [];
      return arr.some((v) => Number(v) > 0);
    },

    // -------------------------
    // ALL SITES Planned vs Actual (horizontal bar)
    // -------------------------
    siteLevelChartSeries() {
      return [
        { name: "Planned", data: this.siteLevelData.planned || [] },
        { name: "Actual", data: this.siteLevelData.actual || [] },
      ];
    },
    siteLevelChartOptions() {
      return {
        chart: { toolbar: { show: false } },
        plotOptions: {
          bar: { horizontal: false, borderRadius: 6, barHeight: "45%" },
        },
        dataLabels: { enabled: false },
        xaxis: { title: {
          text: "Site Code",
        }, categories: this.siteLevelData.categories || [] },
         yaxis: {
        title: {
          text: "No of Subjects",
        },
        min: 0,
      },
        legend: { position: "top" },
        tooltip: { shared: true, intersect: false },
      };
    },

    // -------------------------
    // Date Range chart (line)
    // -------------------------
    dateRangeChartSeries() {
      return [
        { name: "Planned", data: this.dateRangeData.planned || [] },
        { name: "Actual", data: this.dateRangeData.actual || [] },
      ];
    },
    dateRangeChartOptions() {
      const label = this.dateRange.siteCodeLabel || "Selected Site";
      return {
        chart: { toolbar: { show: false } },
        stroke: { curve: "smooth", width: 3 },
        dataLabels: { enabled: false },
        xaxis: { title: {
          text: "Date",
        }, categories: this.dateRangeData.categories || [] },
         yaxis: {
        title: {
          text: "No of Subjects",
        } },
        legend: { position: "top" },
        subtitle: { text: label },
        tooltip: { shared: true, intersect: false, y: { formatter: (val) => `${val}` } },
      };
    },
  },

  methods: {
    // -------------------------
    // KPI API (study-level)
    // -------------------------
    async getenrolmentpercentage() {
      const idtoken = store.getters.getIdToken;
      this.studyId = store.getters.getStudyIs;

      try {
        const url =
          this.baseapi +
          "/forms/rbqm/getenrolmentpercentage?studyId=" +
          encodeURIComponent(this.studyId);

        const res = await axios.get(url, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        });

        // API returns OBJECT
        const d = res?.data || {};

        const planned = Number(d.planned);
        const actual = Number(d.actual);
        const pct = Number(d.percentage);

        this.kpis.totalPlanned = Number.isFinite(planned) ? planned : 0;
        this.kpis.totalActual = Number.isFinite(actual) ? actual : 0;
        this.kpis.enrollmentPercent = Number.isFinite(pct) ? pct : 0;
      } catch (err) {
        console.log("getenrolmentpercentage error:", err);
      }
    },

    // -------------------------
    // API: Site summary chart
    // -------------------------
    async summarychartdata() {
      const idtoken = store.getters.getIdToken;
      const studyId = store.getters.getStudyIs;

      this.summaryLoading = true;

      try {
        const url =
          this.baseapi +
          "/management/site/sitesummery?studyId=" +
          encodeURIComponent(studyId);

        const res = await axios.get(url, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        });

        const d = res?.data?.data ? res.data.data : res?.data || {};
        const keys = ["New", "Open", "Enrolled", "Completed", "Terminated"];

        const labels = keys.map((k) => {
          const tkey = "navigations." + String(k).toLowerCase();
          return this.$t && this.$t(tkey) ? this.$t(tkey) : k;
        });

        const values = keys.map((k) => {
          const v = Number(d[k]);
          return Number.isFinite(v) ? v : 0;
        });

        this.summarychart.dataseries = [
          { name: this.$t("navigations.site summary"), data: values.slice() },
        ];

        this.summarychart.chartOptions = Object.assign({}, this.summarychart.chartOptions, {
          xaxis: {title: {
          text: "Count",
        }, categories: labels.slice() },
           yaxis: {
        title: {
          text: "Status",
        }
        },
        });

        this.summaryChartKey = Date.now();
      } catch (err) {
        console.log(err);
      } finally {
        this.summaryLoading = false;
      }
    },

    // -------------------------
    // API: Subject summary chart
    // -------------------------
    async patientchartdata(siteId) {
      if (!siteId) {
        this.patientchart.piedataseries = [0, 0, 0, 0, 0];
        return;
      }

      const idtoken = store.getters.getIdToken;

      try {
        const res = await axios.get(
          `${this.baseapi}/management/patient/patientstatuscount?siteId=${encodeURIComponent(siteId)}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );

        const values = [
          res.data.New == null ? 0 : res.data.New,
          res.data.Enrolled == null ? 0 : res.data.Enrolled,
          res.data.Withdrawn == null ? 0 : res.data.Withdrawn,
          res.data.Completed == null ? 0 : res.data.Completed,
          res.data["Visit Ongoing"] == null ? 0 : res.data["Visit Ongoing"],
        ];

        this.patientchart.piedataseries = values.slice();
      } catch (err) {
        console.log(err);
      }
    },

    // -------------------------
    // Helpers
    // -------------------------
    formatMonthLabel(isoStart) {
      const d = new Date(isoStart);
      if (isNaN(d.getTime())) return String(isoStart || "");
      return d.toLocaleString("en-US", { month: "short", year: "numeric" });
    },

    // -------------------------
    // ALL SITES API for Planned vs Actual
    // -------------------------
    async fetchPlannedVsActualAllSites() {
      const idtoken = store.getters.getIdToken;
      const studyId = store.getters.getStudyIs;

      const url =
        `${this.baseapi}/management/site/getsiteenrollmentcount?StudyId=${studyId}`;

      const res = await axios.get(url, {
        headers: {
          Authorization: "Bearer " + idtoken,
          "Content-Type": "application/json",
        },
      });

      return Array.isArray(res?.data) ? res.data : [];
    },

    async loadPlannedVsActualAllSites() {
      this.siteLevelLoading = true;

      try {
        const rows = await this.fetchPlannedVsActualAllSites();

        rows.sort((a, b) =>
          String(a?.siteCode || "").localeCompare(String(b?.siteCode || ""))
        );

        this.siteLevelData.categories = rows.map((r) => r?.siteCode || "Unknown");
        this.siteLevelData.planned = rows.map((r) => Number(r?.expectedTotalSubjects) || 0);
        this.siteLevelData.actual = rows.map((r) => Number(r?.actualEnrolment) || 0);
      } catch (err) {
        console.log("loadPlannedVsActualAllSites error:", err);
        this.siteLevelData = { categories: [], planned: [], actual: [] };
      } finally {
        this.siteLevelLoading = false;
      }
    },

    // -------------------------
    // SINGLE SITE API for Date Range (returns array -> take first)
    // -------------------------
    async fetchEnrollmentApi(siteId) {
      const idtoken = store.getters.getIdToken;
      const studyId = store.getters.getStudyIs;
      const url =
        `${this.baseapi}/management/site/getsiteenrollmentcount?StudyId=${studyId}&SiteId=` +
        encodeURIComponent(siteId);

      const res = await axios.get(url, {
        headers: {
          Authorization: "Bearer " + idtoken,
          "Content-Type": "application/json",
        },
      });

      const payload = res?.data;

      // API returns array now -> pick first
      if (Array.isArray(payload)) return payload[0] || {};
      return payload || {};
    },

    // Date Range ONLY
    async fetchSiteEnrollmentOnce(siteId) {
      if (!siteId) return;

      this.dateRangeLoading = true;

      try {
        const d = await this.fetchEnrollmentApi(siteId);

        const siteCodeLabel = d?.siteCode || "Selected Site";

        const rows = Array.isArray(d.enrollmentScheduleStatus)
          ? d.enrollmentScheduleStatus
          : [];

        rows.sort((a, b) => {
          const ta = new Date(a?.startDate).getTime();
          const tb = new Date(b?.startDate).getTime();
          return (isNaN(ta) ? 0 : ta) - (isNaN(tb) ? 0 : tb);
        });

        this.dateRange.siteCodeLabel = siteCodeLabel;
        this.dateRangeData.categories = rows.map((r) => this.formatMonthLabel(r?.startDate));
        this.dateRangeData.planned = rows.map((r) => Number(r?.expected) || 0);
        this.dateRangeData.actual = rows.map((r) => Number(r?.actual) || 0);
      } catch (err) {
        console.log("fetchSiteEnrollmentOnce error:", err);
        this.dateRange.siteCodeLabel = "";
        this.dateRangeData = { categories: [], planned: [], actual: [] };
      } finally {
        this.dateRangeLoading = false;
      }
    },

    // -------------------------
    // Site list + initial load
    // -------------------------
    async sitedata(currentstudyid, idtoken) {
      this.sites = [];

      try {
        const res = await axios.get(
          `${this.baseapi}/management/site/getallsitesbyuser?studyId=${encodeURIComponent(
            currentstudyid
          )}&sortProperty=siteCode&IsDes=false&getAll=false`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );

        (res.data || []).forEach((item) => this.sites.push(item));
        await this.setinitialdata();
      } catch (err) {
        console.log(err);
      }
    },

    async setinitialdata() {
      // first site for general charts
      this.siteCode = this.sites.length ? this.sites[0].siteID : "";

      // KPI activeSites from list
      this.kpis.activeSites = Array.isArray(this.sites) ? this.sites.length : 0;

      // charts
      await this.summarychartdata();
      await this.patientchartdata(this.siteCode);

      await this.loadPlannedVsActualAllSites();

      this.commonSiteId = this.sites.length ? this.sites[0].siteID : "";

      if (this.commonSiteId) {
        await this.fetchSiteEnrollmentOnce(this.commonSiteId);
      }
    },

    async getcount() {
      const idtoken = store.getters.getIdToken;
      this.valnow = store.getters.getStudyIs;
      await this.sitedata(this.valnow, idtoken);
    },

    // -------------------------
    // Study helpers
    // -------------------------
    jwtDecrypt(token) {
      const base64Url = token.split(".")[1];
      const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split("")
          .map(function (c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join("")
      );
      return JSON.parse(jsonPayload);
    },

    async setdefaultstudy() {
      if (!this.valnow) {
        const idtoken = store.getters.getIdToken;
        this.userId = this.jwtDecrypt(idtoken).sub;

        try {
          const res = await axios.get(this.baseUrl + "getdefaultstudy?id=" + this.userId, {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          });

          if (res && res.data && res.data.studyID) {
            this.currentStudy = res.data.studyID;
            store.dispatch("setStudyID", res.data.studyID);
          }
        } catch (err) {
          console.log(err);
        }
      }

      this.valnow = store.getters.getStudyIs;
    },

    async loadstudy() {
      const idtoken = store.getters.getIdToken;
      const usermail = jwt_decode(idtoken).email;

      try {
        const res = await axios.get(
          `${this.baseapi}/management/study/getallstudy?user=${encodeURIComponent(usermail)}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );
        this.studies = res.data;
      } catch (err) {
        console.log(err);
      }

      this.valnow = store.getters.getStudyIs;
    },
  },
};